import { HttpClient } from "@angular/common/http";
import { Config, ConfigEnvService } from "./configEnvService";

export abstract class BaseGridService {
  private config: Config;
  public baseUrl = "";
  public controller = "";
  constructor(
    public http: HttpClient,
    envService: ConfigEnvService,
    controller: string
  ) {
    this.config = envService.getConfigData();
    this.baseUrl = this.config.serverUrl;
    this.controller = controller;
  }
}
